import { createSelector } from 'reselect'

/**
 * Leaf selectors for checkout cart.mode flags.
 * Kept out of tourV2Selectors so payment accommodation totals can read tour
 * post-purchase mode without the funnel ↔ tourV2Selectors ↔ navigationSelectors cycle.
 */
export const getIsPostPurchaseTourOptionalExperience = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (mode) => mode === 'tour-optional-experiences',
)

export const getIsPostPurchaseTourAccommodation = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (mode) => mode === 'tour-accommodation',
)

export const getIsPostPurchaseTourChangeDates = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (mode) => mode === 'tour-change-dates',
)

export const getIsPaymentScheduleBalance = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (mode) => mode === 'payment-schedule-balance',
)

export const getIsDepositBalance = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (mode) => mode === 'deposit-balance',
)

export const getIsReserveBalance = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (mode) => mode === 'reserve-balance',
)

export const getIsReserveForZeroDeposit = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (mode) => mode === 'reserve-for-zero-deposit',
)
